import { withInstall, withNoopInstall } from '@jdesign-vue/utils'

import Select from './src/select.vue'
import Option from './src/option.vue'
import ImgLabel from './src/img-label.vue'
import OptionGroup from './src/option-group.vue'

export const JdSelect = withInstall(Select, {
  Option,
  OptionGroup,
})
export default JdSelect
export const JdOption = withNoopInstall(Option)
export const JdOptionGroup = withNoopInstall(OptionGroup)
export const JdOptionImgLabel = withNoopInstall(ImgLabel)

export * from './src/token'
